import { lazy } from 'react'

export default {
    path: '/fornitori',
    title: 'Fornitori',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:fornitoreId',
            title: 'Fornitore: {{params.fornitoreId}}',
            drawer: false,
            component: lazy(() => import('./detail'))
        }
    ]
}